import React from "react";

import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import { FranchiseType } from "@hubcapp/types";
import { formatCurrency, getAreaAvatarColor } from "@ds-developer/frontend";

import { OtherAreaCardProps } from "../../types";
import { getAreaDefaultPrice, getCoverageCount } from "../../helpers";
import AreaAvatar from "../AreaAvatar";
import AreaContainer from "../../Area";
import AreaContent from "../AreaContent";

const OtherArea: React.FC<OtherAreaCardProps> = ({ franchise, coverage }) => {
  const history = useHistory();
  const proposition = franchise?.proposition;
  const franchiseType = proposition?.type;
  const price = getAreaDefaultPrice(coverage, franchise);

  return (
    <AreaContainer
      avatar={
        <Grid item xs={12} sm={3}>
          {coverage && coverage.region.regionName && (
            <AreaAvatar
              initials={coverage.region.regionCode}
              label={coverage.region.regionName}
              color={getAreaAvatarColor(coverage.region.regionName)}
            />
          )}
        </Grid>
      }
      editable={franchiseType === FranchiseType.Motability}
      onClick={() => {
        history.push(`/settings/areas-and-prices/area/${coverage.id}`);
      }}
    >
      <Grid item xs={6} sm={2}>
        <AreaContent
          label="Districts coverage"
          text={getCoverageCount(coverage.region.districts)}
        />
      </Grid>
      <Grid item xs={3} sm={2}>
        {price && <AreaContent label="Rate" text={formatCurrency(price)} />}
      </Grid>
      {/* Empty items so that everything lines up on desktop :/ */}
      <Grid item xs="auto" sm={2}>
        <AreaContent label="" text="" />
      </Grid>
      <Grid item xs="auto" sm={2}>
        <AreaContent label="" text="" />
      </Grid>
    </AreaContainer>
  );
};

export default OtherArea;
